import { LinearGradient } from 'expo-linear-gradient'
import React from 'react'
import { Pressable } from 'react-native'

import { Avatar } from 'widgets/Avatar'
import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { Text } from 'widgets/Text'

import { Media } from 'types/media'

type UploadAvatarUIProps = {
  size: number
  avatar: Media
  onPress: () => void
}

export const UploadAvatarUI = ({ size, avatar, onPress }: UploadAvatarUIProps) => {
  return (
    <Pressable onPress={onPress}>
      <Box
        width={size}
        height={size}
        align='center'
        justifyContent='center'
        style={{ borderRadius: size / 2 }}
      >
        <LinearGradient
          colors={['#F91D75', '#4578F1']}
          start={{ x: 0.5, y: 0.0 }}
          end={{ x: 0.5, y: 1.0 }}
          style={{
            padding: 3,
            borderRadius: size / 2,
          }}
        >
          <Box
            width={size - 6}
            height={size - 6}
            align='center'
            justifyContent='center'
            backgroundColor='greyDarkest'
            style={{ borderRadius: (size - 6) / 2 }}
          >
            <Box
              width={size - 12}
              height={size - 12}
              align='center'
              justifyContent='center'
              margin='xs'
            >
              {avatar.url?.length !== 0 && (
                <Box>
                  <Avatar width={size - 12} height={size - 12} image={avatar} />
                </Box>
              )}
              {avatar.url?.length === 0 && (
                <Box align='center' justifyContent='center'>
                  <Box margin={{ bottom: 'sm' }}>
                    <Icon name='camera' color='white' size={36} />
                  </Box>
                  <Text fontSize='xs' align='center' numberOfLines={1} color='white'>
                    Add Profile Photo
                  </Text>
                </Box>
              )}
            </Box>
          </Box>
        </LinearGradient>
      </Box>
    </Pressable>
  )
}
